export type ThemeMode = "light" | "dark" | "device";

const STORAGE_KEY = "moneytor-theme";
const THEME_CHANGE_EVENT = "moneytor-theme-change";

export function getStoredTheme(): ThemeMode {
  try {
    const val = localStorage.getItem(STORAGE_KEY);
    if (val === "light" || val === "dark" || val === "device") return val;
  } catch {
    // SSR or localStorage unavailable
  }
  return "device";
}

export function setStoredTheme(mode: ThemeMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // localStorage unavailable
  }
  window.dispatchEvent(new CustomEvent(THEME_CHANGE_EVENT, { detail: mode }));
}

export function resolveTheme(mode: ThemeMode): "light" | "dark" {
  if (mode === "light" || mode === "dark") return mode;
  if (typeof window === "undefined") return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function applyThemeClass(isDark: boolean): void {
  const root = document.documentElement;
  root.classList.toggle("dark", isDark);
  // Keep the native color-scheme in sync with the resolved theme so UA-rendered
  // form controls (e.g. login inputs) never paint dark on a light page.
  root.style.colorScheme = isDark ? "dark" : "light";
}

export { THEME_CHANGE_EVENT };
